import { api } from "../../api/http";

const BASE = "/api/backoffice/final-exams/";

export async function listFinalExams(params = {}) {
	const res = await api.get(BASE, { params });
	return res.data;
}

export async function getFinalExam(id) {
	const res = await api.get(`${BASE}${id}/`);
	return res.data;
}

export async function updateFinalExamSettings(id, payload) {
	const res = await api.patch(`${BASE}${id}/settings/`, payload);
	return res.data;
}

export async function resetFinalExam(id, reason) {
	const res = await api.post(`${BASE}${id}/reset/`, { reason });
	return res.data;
}

export async function resetStudentFinalExam(id, studentId, reason) {
	const res = await api.post(`${BASE}${id}/reset-student/`, {
		student_id: studentId,
		reason,
	});
	return res.data;
}
